'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = _list;

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    entries: [],
    state: _constants.OK
};

function _list(root, listName) {
    if (!root || !root.list || !root.list[listName]) return defaults;

    var list = root.list[listName];
    return (0, _extends3.default)({}, defaults, list);
}